import Loadable from '@townsquare/loadable';
import { agentProfileRoute } from '@townsquare/routes/agent-profile';
import { embeddableDirectoryRoute } from '@townsquare/routes/embeddable-directory';
import { kudosProfileRoute } from '@townsquare/routes/kudos-profile';
import { profileRoute } from '@townsquare/routes/profile';
import { teamProfileRoute } from '@townsquare/routes/team-profile';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';

const DirectoryViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "DirectoryPage" */ './components/DirectoryView'),
  loading: () => null,
});

profileRoute.component = DirectoryViewLoadable;
export const profileRouterRoute = profileRoute;

teamProfileRoute.component = DirectoryViewLoadable;
export const teamProfileRouterRoute = teamProfileRoute;

agentProfileRoute.component = DirectoryViewLoadable;
export const agentProfileRouterRoute = agentProfileRoute;

kudosProfileRoute.component = DirectoryViewLoadable;
export const kudosProfileRouterRoute = kudosProfileRoute;

embeddableDirectoryRoute.component = DirectoryViewLoadable;
embeddableDirectoryRoute.resources = [titanEapCrossFlowQueryResource];
export const embeddableDirectoryRouterRoute = embeddableDirectoryRoute;
